// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@synd/App/Components/Notify";
import dataTableStyles from "@synd/App/SharedStyles/DataTableStyles";
import { billToSelectorStyles } from "@synd/Overrides/Components/BillToSelector";
import { mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

billToSelectorStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 20px 0;
    `,
};

billToSelectorStyles.addressesLoadFailedText = {
    ...mergeWithCss(getNotifyStyle("danger", true), {
        css: css`
            margin: 0;
        `,
    }),
};

billToSelectorStyles.noBillTosText = { ...dataTableStyles.noResultsText };
